<div *ngIf="dataService.isKioskTablet">
<div class="logoContainer">
  <img id="logo" src="/assets/logo/logo_grey.svg">
</div>

<h1 style="position: absolute; top: 50%; left:50%; transform: translate(-50%, -50%); font-size: 128pt;" *ngIf="counter">{{counter}}</h1>
</div>